import React, { Component } from "react";
import { connect } from "react-redux";
import Dialog from "material-ui/Dialog";
import { change, Field, reduxForm } from 'redux-form';
import moment from 'moment';


import { CancelButton } from '../../../../../../../components/buttons';
import SmallLoader from '../../../../../../../img/small-loader.gif';
import { renderAutoCompleteSingleSelect, renderDateField, renderCheckBox } from '../../../../../../../components/reduxFields';
import { getBehaviourReductionSingleGraphData } from '../actions/behaviorActions';
import AverageDurationGraph from './averageDurationGraph';
import TotalCountGraph from './totalCountGraph';
import TotalDurationGraph from './totalDurationGraph';
import TimeOfDayGraph from './timeOfDayGraph';
import PerCountGraph from './perCountGraph';

const rateGraphType = [
  { id: 1, value: "Rate Per Minute" },
  { id: 2, value: "Rate Per 5 Minute" },
  { id: 3, value: "Rate Per 15 Minute" },
  { id: 4, value: "Rate Per 30 Minute" },
  { id: 5, value: "Rate Per Hour" },
  { id: 6, value: "Total Count" },
  { id: 7, value: "Total Duration" },
  { id: 8, value: "Average Duration" },
  { id: 9, value: "Time of day" }
]

class DurationGraphModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
      selectedGraphType: null,
      FromDate: new Date(new Date().setDate(new Date().getDate() - 7)),
      ToDate: new Date(),
      displayLegendCheckBox: true,
      disableLegend: true,
      hideGridlines: false,
      displayAverageCheckBox: true,
      displayAverage: false,
      graphByStaff: false,
      displaySavedPhaseChangeLines: false,      
      phaseChangeLineDataFlag : true,      
      displayPhaseChangeLinesCheckbox: true,
    };
    this.setPhaselineState = this.setPhaselineState.bind(this);    
  }

  componentWillMount() {
    if(this.props.recordingTypeName.toUpperCase() === "RATE") {
        this.setState({
            graphType: rateGraphType
        });
    }
  }

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    if (this.state.open) {
      this.setState({ open: false });
      this.props.closeDialog();
    }
  };

  componentWillReceiveProps(nextProps) {
    let self = this;
    document.onkeydown = function(evt) {
      evt = evt || window.event;
      if (evt.keyCode === 27) {
        self.handleClose();
      }
    };
  }

  checkDisable = (event, Id) => {   
    if(Id === 'disableLegend')
    {
      this.setState({ disableLegend: !event.target.checked }, () => this.loadData());
    }
    else if(Id === 'hideGridlines')
    {
      this.setState({ hideGridlines: event.target.checked }, () => this.loadData());
    }
    else if(Id === 'displayAverage')
    {
      this.setState({ displayAverage: event.target.checked }, () => this.loadData());
    }
    else if(Id === 'graphByStaff')
    {
      this.setState({ graphByStaff: event.target.checked ? true : false }, () => this.loadData());      
    }  
    else if(Id === 'displaySavedPhaseChangeLines')
    {
      this.setState({ displaySavedPhaseChangeLines: event.target.checked ? true : false,
        phaseChangeLineDataFlag : true,        
      });      
    } 
  }

  loadData() {
    let FromDate = moment(this.state.FromDate).format('YYYY-MM-DD');
    let ToDate =  moment(this.state.ToDate).format('YYYY-MM-DD');
    if(this.state.selectedGraphType)
    {
      this.props.getBehaviourReductionSingleGraphData(this.props.patientId, this.props.recordingTypeName, this.props.behaviorsReductionId, FromDate, ToDate, this.state.graphByStaff, this.state.selectedGraphType.toUpperCase());
    }
  }

  handleNewRequestGraphType = (input, selectedRecord) => { 
    input.onChange(selectedRecord.value);    
    this.setState({ 
      displaySavedPhaseChangeLines: false,      
      phaseChangeLineDataFlag : true,      
    }, () => { 
      this.props.dispatch(change('RateGraphModalForm', `displaySavedPhaseChangeLines`, false));      
    });
    if(selectedRecord.label.toUpperCase() === "AVERAGE DURATION") {  
        this.setState({
            displayLegendCheckBox : true,
            selectedGraphType: selectedRecord.label,
            displayAverageCheckBox: true,
            displayPhaseChangeLinesCheckbox: true,
        }, () => this.loadData());  
    } else  if(selectedRecord.label.toUpperCase() === "TOTAL COUNT") {  
        this.setState({
            displayLegendCheckBox : true,
            selectedGraphType: selectedRecord.label,
            displayAverageCheckBox: true,
            displayPhaseChangeLinesCheckbox: true,
        }, () => this.loadData());
    } else  if(selectedRecord.label.toUpperCase() === "TOTAL DURATION") {   
        this.setState({
            displayLegendCheckBox : true,
            selectedGraphType: selectedRecord.label,
            displayAverageCheckBox: true,
            displayPhaseChangeLinesCheckbox: true,
        }, () => this.loadData());
    } else  if(selectedRecord.label.toUpperCase() === "TIME OF DAY") {   
      this.setState({
          displayLegendCheckBox : false,
          selectedGraphType: selectedRecord.label,
          displayAverageCheckBox: false,
          displayPhaseChangeLinesCheckbox: true,
      }, () => this.loadData());
    } else if (selectedRecord.label === 'Rate Per Minute') {
      this.setState({
          selectedGraphType: selectedRecord.label,
          displayLegendCheckBox : true,          
          displayAverageCheckBox: true,
          displayPhaseChangeLinesCheckbox: true,
      }, () => this.loadData());
    } else if (selectedRecord.label === 'Rate Per 5 Minute') {
        this.setState({
            selectedGraphType: selectedRecord.label,
            displayLegendCheckBox : true,          
            displayAverageCheckBox: true,
            displayPhaseChangeLinesCheckbox: true,
        }, () => this.loadData());
    } else if (selectedRecord.label === 'Rate Per 15 Minute') {
        this.setState({
            selectedGraphType: selectedRecord.label,
            displayLegendCheckBox : true,          
            displayAverageCheckBox: true,
            displayPhaseChangeLinesCheckbox: true,
        }, () => this.loadData());
    } else if (selectedRecord.label === 'Rate Per 30 Minute') {
        this.setState({
            selectedGraphType: selectedRecord.label,
            displayLegendCheckBox : true,          
            displayAverageCheckBox: true,
            displayPhaseChangeLinesCheckbox: true,
        }, () => this.loadData());
    } else if (selectedRecord.label === 'Rate Per Hour') {
        this.setState({
            selectedGraphType: selectedRecord.label,
            displayLegendCheckBox : true,          
            displayAverageCheckBox: true,
            displayPhaseChangeLinesCheckbox: true,
        }, () => this.loadData());
    } 
  }

  onDateChange = (input, value) => {
    input.onChange(moment(value).format());
    this.setState({ [input.name]: value,
      displaySavedPhaseChangeLines: false,      
      phaseChangeLineDataFlag : true, }, () => { 
        this.props.dispatch(change('RateGraphModalForm', `displaySavedPhaseChangeLines`, false));    
        this.loadData();});
  }

  setPhaselineState(phaseChangeLineDataFlag) {          
    this.setState({
      phaseChangeLineDataFlag : phaseChangeLineDataFlag,      
    });
  }

  renderLoading() {
    return (
      <div>
        {this.props.loading ? (
          <div className="full_loader top0">
            <div className="small-loader">
              <img src={SmallLoader} alt="" />
            </div>
          </div>
        ) : null}
      </div>
    );
  }

  render() {
    const actions = [
        <CancelButton className="mr-15" onTouchTap={this.handleClose} />
      ];
    return <Dialog className="custom_modal_new_appointment" title={this.props.modalTitle} modal={false} open={this.state.open} actions={actions} autoScrollBodyContent={true}>
        {this.renderLoading()}
        <div className='row'>
            <div className="col-sm-3 mt-40">
                <Field
                    name='graphTypeId'
                    label="Graph Type"
                    options={this.state.graphType}
                    handleNewRequest={this.handleNewRequestGraphType}
                    component={renderAutoCompleteSingleSelect}
                />
            </div>
            <div className="col-sm-3 mt-10">
                <Field
                    name="FromDate"
                    placeholder="From Date"
                    locale="en-US"
                    selected={this.state.FromDate}
                    onDateChange={this.onDateChange}
                    openToYearSelection={true}
                    component={renderDateField} />
            </div>
            <div className="col-sm-3 mt-10">
                <Field
                    name="ToDate"
                    placeholder="To Date"
                    locale="en-US"
                    minDate={this.state.FromDate}
                    selected={this.state.ToDate}
                    openToYearSelection={true}
                    onDateChange={this.onDateChange}
                    component={renderDateField} />
            </div>
            {this.state.displayLegendCheckBox &&
            <div className="col-sm-3 mt-10">
                <Field 
                    className="mt20 mb0" 
                    name="disableLegend" 
                    label="Disable Legends"
                    onChange={(e) => this.checkDisable(e, 'disableLegend')}
                    component={renderCheckBox} />
            </div>}
            <div className="col-sm-3 mt-10">
                <Field 
                    className="mt20 mb0" 
                    name="hideGridlines" 
                    label="Hide Gridlines"
                    onChange={(e) => this.checkDisable(e, 'hideGridlines')}
                    component={renderCheckBox} />
            </div>
            {this.state.displayAverageCheckBox &&
            <div className="col-sm-3 mt-10">
                <Field 
                    className="mt20 mb0" 
                    name="displayAverage" 
                    label="Display Average"
                    onChange={(e) => this.checkDisable(e, 'displayAverage')}
                    component={renderCheckBox} />
            </div>}
            <div className="col-sm-3 mt-10">
                <Field 
                    className="mt20 mb0" 
                    name="graphByStaff" 
                    label="View By Staff"
                    onChange={(e) => this.checkDisable(e, 'graphByStaff')}
                    component={renderCheckBox} />
            </div>
            {this.state.displayPhaseChangeLinesCheckbox &&
            <div className="col-sm-3 mt-10">
                <Field 
                    className="mt20 mb0" 
                    name="displaySavedPhaseChangeLines" 
                    label="Display saved phase change lines"
                    onChange={(e) => this.checkDisable(e, 'displaySavedPhaseChangeLines')}
                    component={renderCheckBox} />
            </div>}
            </div>
          <div>
            {
                (this.state.selectedGraphType !== null && this.state.selectedGraphType.toUpperCase() === "AVERAGE DURATION") && <AverageDurationGraph graphTitle={this.props.modalTitle} disableLegend={this.state.disableLegend} hideGridlines={this.state.hideGridlines} displayAverage={this.state.displayAverage} graphByStaff={this.state.graphByStaff} xAxisName={this.state.selectedGraphType}  
                displaySavedPhaseChangeLines = {this.state.displaySavedPhaseChangeLines} phaseChangeLineDataFlag = {this.state.phaseChangeLineDataFlag} setPhaselineState={this.setPhaselineState} 
                />
            }
            {
                (this.state.selectedGraphType !== null && this.state.selectedGraphType.toUpperCase() === "TOTAL COUNT") && <TotalCountGraph graphTitle={this.props.modalTitle} disableLegend={this.state.disableLegend} hideGridlines={this.state.hideGridlines} displayAverage={this.state.displayAverage} graphByStaff={this.state.graphByStaff} xAxisName={this.state.selectedGraphType} 
                displaySavedPhaseChangeLines = {this.state.displaySavedPhaseChangeLines} phaseChangeLineDataFlag = {this.state.phaseChangeLineDataFlag} setPhaselineState={this.setPhaselineState} 
                />
            }
            {
                (this.state.selectedGraphType !== null && this.state.selectedGraphType.toUpperCase() === "TOTAL DURATION") && <TotalDurationGraph graphTitle={this.props.modalTitle} disableLegend={this.state.disableLegend} hideGridlines={this.state.hideGridlines} displayAverage={this.state.displayAverage} graphByStaff={this.state.graphByStaff} xAxisName={this.state.selectedGraphType} 
                displaySavedPhaseChangeLines = {this.state.displaySavedPhaseChangeLines} phaseChangeLineDataFlag = {this.state.phaseChangeLineDataFlag} setPhaselineState={this.setPhaselineState} 
                />
            }
            {
                (this.state.selectedGraphType !== null && this.state.selectedGraphType.toUpperCase() === "TIME OF DAY") && <TimeOfDayGraph graphTitle={this.props.modalTitle} hideGridlines={this.state.hideGridlines} graphByStaff={this.state.graphByStaff} xAxisName={this.state.selectedGraphType} 
                displaySavedPhaseChangeLines = {this.state.displaySavedPhaseChangeLines} phaseChangeLineDataFlag = {this.state.phaseChangeLineDataFlag} setPhaselineState={this.setPhaselineState} 
                />
            }
            {
                (this.state.selectedGraphType !== null && (this.state.selectedGraphType.toUpperCase() === "RATE PER MINUTE" || this.state.selectedGraphType.toUpperCase() === "RATE PER 5 MINUTE" || 
                this.state.selectedGraphType.toUpperCase() === "RATE PER 15 MINUTE" || this.state.selectedGraphType.toUpperCase() === "RATE PER 30 MINUTE" || this.state.selectedGraphType.toUpperCase() === "RATE PER HOUR" )) && <PerCountGraph graphTitle={this.props.modalTitle} disableLegend={this.state.disableLegend} hideGridlines={this.state.hideGridlines} displayAverage={this.state.displayAverage} graphByStaff={this.state.graphByStaff} xAxisName={this.state.selectedGraphType} 
                displaySavedPhaseChangeLines = {this.state.displaySavedPhaseChangeLines} phaseChangeLineDataFlag = {this.state.phaseChangeLineDataFlag} setPhaselineState={this.setPhaselineState} 
                />
            }
            
        </div>
      </Dialog>;
  }
}

DurationGraphModal = reduxForm({
    form: 'RateGraphModalForm',
    enableReinitialize: true,
})(DurationGraphModal);


export default connect(null,{getBehaviourReductionSingleGraphData})(DurationGraphModal);



// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollection/BehaviorReductiom/Behavior/RateGraphModal/index.js